module.exports = __webpack_public_path__ + "img/people.7c7f39e6.svg";